<template>
  <div class="start flex-grow-1 flex-fill">
    <Translate />
    <section class="row">
      <div class="col-4 px-3 py-5 d-none d-md-flex"></div>
      <div class="col-24 col-md-16 px-3 align-items-center d-flex">
        <div class="row align-itens-center">
          <div
            class="col-24 col-md-11 min-h text-right justify-content-start align-items-end d-flex flex-column pr-3"
          >
            <img src="../../assets/svg/logo.svg" class="align-self-end mb-2" />
            <h1
              class="title"
              v-text="$ml.get('yourSecurityPlatformAndBugReward')"
            >
              A sua plataforma de segurança e recompensa por bugs
            </h1>
            <p
              class="min-h d-none d-md-flex"
              v-text="$ml.get('youWillReceiveReportsFromCommunity')"
            >
              Você recebe feedbacks dos especialistas de segurança da nossa
              comunidade, sem custo adicional, enquanto minimiza as chances de
              expor suas vulnerabilidades na mídia ou redes sociais
            </p>
          </div>
          <div
            class="col-2 min-h d-none d-md-flex justify-content-center py-3 mb-5"
          >
            <span class="line align-self-center"></span>
          </div>

          <div
            class="col-24 col-md-11 min-h text-left justify-content-start align-items-end d-flex flex-column mt-5 pl-md-3"
          >
            <div class="card w-100">
              <div class="card-body">
                <h5 v-text="$ml.get('letsCompleteYourRegistration')">
                  Vamos concluir seu cadastro!
                </h5>
                <p v-text="$ml.with(companyName).get('youWereInvitedPartOf')">
                  Você foi convidado a fazer parte do time , Basta informar os
                  dados da sua conta.
                </p>
                <transition name="fade">
                  <div v-show="msgdanger" class="alert alert-danger">
                    {{ msgdanger }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgWarning" class="alert alert-warning">
                    {{ msgWarning }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgSuccess" class="alert alert-success">
                    <font v-text="$ml.get('accountCreatedSuccessfully')"></font>
                    <font v-text="$ml.get('youWillBeRedirectedIn')"
                      >Você será redirecionado em</font
                    >
                    {{ seconds }}
                    <font v-text="$ml.get('seconds')">segundos</font>.
                  </div>
                </transition>

                <form @submit.prevent="executeRecaptcha" v-if="!msgdanger">
                  <div class="row">
                    <div class="col px-1">
                      <p><strong v-text="this.email"></strong></p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="contactName"
                          :placeholder="$ml.get('informTheUser') + '!'"
                          maxlength="100"
                        />
                        <label
                          v-if="
                            submitStatus === 'ERROR' && !$v.contactName.required
                          "
                          class="lblError"
                          v-text="$ml.get('enterUserName')"
                          >Informe o nome do usuário</label
                        >
                        <label
                          v-if="
                            submitStatus === 'ERROR' && !$v.contactName.regexOTN
                          "
                          class="lblError"
                          v-text="$ml.get('cannotEnterSpecialCharacters')"
                          >Não é possível inserir caracteres especiais</label
                        >
                        <label
                          v-if="
                            submitStatus === 'ERROR' &&
                              !$v.contactName.minLength
                          "
                          class="lblError"
                          v-text="
                            $ml
                              .with('f', $v.contactName.$params.minLength.min)
                              .with('l', 100)
                              .get('theNameMustBeFromToCharacters')
                          "
                          >É preciso ter pelo menos caracteres.</label
                        >
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="name"
                          :placeholder="$ml.get('enterYourFullName') + '!'"
                          maxlength="100"
                        />
                        <label
                          v-if="submitStatus === 'ERROR' && !$v.name.required"
                          class="lblError"
                          v-text="$ml.get('enterUserName')"
                          >Informe o nome do usuário</label
                        >
                        <label
                          v-if="submitStatus === 'ERROR' && !$v.name.regexOTN"
                          class="lblError"
                          v-text="$ml.get('cannotEnterSpecialCharacters')"
                          >Não é possível inserir caracteres especiais</label
                        >
                        <label
                          v-if="submitStatus === 'ERROR' && !$v.name.minLength"
                          class="lblError"
                          v-text="
                            $ml
                              .with('f', $v.name.$params.minLength.min)
                              .with('l', 100)
                              .get('theNameMustBeFromToCharacters')
                          "
                          >É preciso ter pelo menos caracteres.</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <the-mask
                          class="form-control"
                          v-model="phone"
                          :mask="['(##) ####-####', '(##) #####-####']"
                          :placeholder="$ml.get('yourPhoneToGetInTouch')"
                        />
                        <label
                          v-if="submitStatus === 'ERROR' && !$v.phone.required"
                          class="lblError"
                          v-text="$ml.get('informThePhoneWithAreaCode')"
                          >Informe o telefone com DDD</label
                        >
                        <label
                          v-if="submitStatus === 'ERROR' && !$v.phone.minLength"
                          class="lblError"
                          v-text="$ml.get('informThePhoneWithAreaCode')"
                          >Informe o telefone com DDD</label
                        >
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control"
                          v-model="password"
                          :placeholder="$ml.get('aSuperStrongPasswordNow')"
                          maxlength="200"
                        />
                        <transition v-if="submitStatus" name="fade">
                          <label class="lblError">{{
                            passwordValidation.errorsString
                          }}</label>
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control"
                          v-model="passwordConfirm"
                          :placeholder="$ml.get('confirmYourPassword')"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            class="lblError"
                            v-if="submitStatus && !$v.passwordConfirm.required"
                            v-text="$ml.get('enterPasswordConfirmation')"
                            >Digite a confirmação de senha</label
                          >
                          <label
                            class="lblError"
                            v-if="
                              submitStatus && !$v.passwordConfirm.sameAsPassword
                            "
                            v-text="$ml.get('passwordsMustMatch')"
                            >As senhas devem ser iguais!</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="col mb-3">
                      <multiselect
                        v-model="selectedCountryOption"
                        :options="countryOptions"
                        :searchable=true
                        :placeholder="$ml.get('selectCountry')"
                        label="name"
                        :custom-label="nameLang"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        :preselect-first="true"
                        :multiple="false"
                      >
                      </multiselect>
                    </div>

                  <div class="custom-checkbox ">
                    <input
                      type="checkbox"
                      id="checkTerms"
                      v-model="checkTerms"
                      name="check"
                    />
                    <label class="form-check-label label-text" for="checkTerms">
                      <font class="m-4"
                        ><font v-text="$ml.get('iAgreeWithThe')"
                          >Eu concordo com o</font
                        >
                        <a
                          href="https://www.bughunt.com.br/termo-uso.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-text="$ml.get('termsOfUse')"
                          >termo de uso</a
                        >.</font
                      >
                    </label>
                  </div>
                  <transition name="fade">
                    <label
                      v-if="submitStatus && !checkTerms"
                      class="lblError"
                      v-text="$ml.get('youMustAgreeToTheTermsOfUse')"
                      >Você precisa concordar com o termo de uso.</label
                    >
                  </transition>

                  <div class="row mt-4 mb-2">
                    <div class="col-auto">
                      <button :disabled="loadingBtn" class="btn btnForm ">
                        <Spinner v-show="loadingBtn" />
                        <span
                          v-show="!loadingBtn"
                          v-text="$ml.get('createMyAccount')"
                        >
                          Criar minha conta!</span
                        >
                      </button>
                    </div>
                    <div
                      class="col-auto d-flex flex-column justify-content-center pl-2"
                    >
                      <router-link
                        tag="a"
                        to="/login"
                        class="btn btn-outline-extra"
                        v-text="$ml.get('iAlreadyHaveAnSccount')"
                      >
                        Eu já tenho conta!
                      </router-link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <recaptcha ref="recaptcha" @verify="registerAccount"></recaptcha>
  </div>
</template>
<script>
import axios from "axios";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import Recaptcha from "../../components/recaptcha.vue";
import { utils } from "../../utils";
import Translate from "../../components/translate.vue";
import { listCountries } from "../../helpers/mocks";

const regexOTN = utils.regexCheck("OTN");

export default {
  components: {
    Recaptcha,
    Translate,
  },
  page: {
    title: "Cadastro",
    meta: [{ name: "description" }],
  },
  data() {
    return {
      name: "",
      companyName: "",
      email: "",
      contactName: "",
      phone: "",
      password: "",
      passwordConfirm: "",
      seconds: 5,
      loadingBtn: false,
      checkTerms: false,
      submitStatus: null,
      msgdanger: "",
      msgWarning: "",
      msgSuccess: "",

      rules: [
        { message: "aNumber", regex: /[0-9]+/ },
        { message: "anUppercaseLetter", regex: /[A-Z]+/ },
        { message: "aLowercaseLetter", regex: /[a-z]+/ },
        { message: "atLeastCharacters", regex: /.{6,}/ },
      ],

      selectedCountryOption: {
        name: "brasil",
        value: "br",
      },
      countryOptions: listCountries,
    };
  },
  validations: {
    name: { required, regexOTN, minLength: minLength(3) },
    contactName: { required, regexOTN, minLength: minLength(3) },
    phone: { required, minLength: minLength(11) },
    email: { required, email },
    passwordConfirm: {
      required,
      sameAsPassword: sameAs("password"),
    },
  },
  computed: {
    passwordValidation() {
      let errorsString = "";
      for (let condition of this.rules) {
        if (!condition.regex.test(this.password)) {
          errorsString = errorsString + this.$ml.get(condition.message);
        }
      }
      return { errorsString };
    },
  },
  mounted() {
    this.$v.$reset();
    let key = this.$route.query;
    this.companyName = key.company;
    this.contactName = key.name;
    this.changeDados(key.k);
  },
  methods: {
    // execute the recaptcha widget
    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },

    changeDados(key) {
      var self = this;
      delete axios.defaults.headers.common["Authorization"];
      axios
        .get(this.$store.getters["getApiUrl"] + `invitation/${key}`)
        .then(function(resp) {
          self.email = resp.data.receiver;
        })
        .catch(function(error) {
          self.loadingBtn = false;
          if (
            error.response.data.message == "Convite não encontrado ou expirado!"
          ) {
            self.msgdanger = self.$ml.get("invitationNotFoundOrExpired");
            return;
          }
          if (error.response.status == 404) {
            self.msgdanger = self.$ml.get("unableToCompleteThisRequest");
            return;
          }
        });
    },

    registerAccount(tokenRecaptcha) {
      this.$v.$touch();
      if (
        this.$v.$invalid ||
        !this.checkTerms ||
        this.passwordValidation.errorsString
      ) {
        this.submitStatus = "ERROR";
        return;
      }

      var self = this;
      this.loadingBtn = true;
      this.msgdanger = "";
      this.msgWarning = "";
      this.msgSuccess = "";

      delete axios.defaults.headers.common["Authorization"];
      axios
        .post(
          this.$store.getters["getApiUrl"] +
            `invitation/${this.$route.query.k}/account`,
          {
            name: self.name,
            contactName: self.contactName,
            phone: {
              areaCode: self.phone.substr(0, 2),
              number: self.phone.substr(2, 11),
            },
            email: self.email,
            password: self.password,
            tokenRecaptcha: tokenRecaptcha,
            country: this.selectedCountryOption.value,
          }
        )
        .then(function() {
          self.msgSuccess = self.name;
          var refreshInterval = setInterval(() => {
            if (self.seconds > 0) {
              self.seconds = self.seconds - 1;
            } else {
              self.loadingBtn = false;
              self.$router.push({
                name: "login",
                params: {
                  email: self.email,
                },
              });
              clearInterval(refreshInterval);
            }
          }, 1000);
        })
        .catch(function(error) {
          self.loadingBtn = false;
          if (error.response) {
            self.msgdanger = self.$ml.get("unableToCompleteThisRequest");
            return;
          }
        });
    },

    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },
  },
};
</script>

<style scoped>
.btnForm {
  width: 173px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.lblError {
  font-size: 11px;
  padding-left: 5px;
  color: red;
  position: absolute;
}
.form-group {
  margin-bottom: 20px;
}

/*General style*/
.form-check-label {
  cursor: pointer;
  color: #666;
  font-size: 15px;
  margin-left: -12px;
}

/*Custom checkboxes style*/
.custom-checkbox input[type="checkbox"] + .label-text:before {
  content: "";
  text-transform: none;
  line-height: 0.8;
  display: inline-block;
  border-radius: 3px;
  border: #730ca8 1px solid;
  padding: 7px;
  position: absolute;
}
.custom-checkbox input[type="checkbox"]:checked + .label-text:before {
  content: "✓";
  color: #730ca8;
  border: #730ca8 1px solid;
  animation: effect 250ms ease-in;
  padding: 1px;
}

@keyframes effect {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(1.3);
  }
  75% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
</style>
